import { useState, useEffect } from 'react'

export const useHasTouch = () => {
  const [hasTouch, setHasTouch] = useState(false)
  useEffect(() => {
    if (!document) return
    setHasTouch('ontouchstart' in document.documentElement)
  }, [])
  return hasTouch
}
